import React from 'react';
import {Routes, Route } from 'react-router-dom';
import About from './about.js';
import Contact from './contact.js';
import UserManual from './userManual.js';
import Skills from './skills.js';
import Blogs from './blogs.js';

const AppRoutes = () => {
    return (
        <Routes>
                {/* Add your routes here */}
                <Route path="" element={ <About/>} />
                <Route path="/contact" element={ <Contact/>} />
                <Route path="/usermanual" element={ <UserManual/>} />
                <Route path="/skills" element={ <Skills/>} />
                <Route path="/blogs" element={ <Blogs/>} />
        </Routes>
    ); 
};

export default AppRoutes;